import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "regenerator-runtime/runtime.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectWithoutProperties from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _asyncToGenerator from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/createSuper";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import BaseMap from './BaseMap';
import MapLoader from './MapLoader';
var AMapEngine = /*#__PURE__*/function (_BaseMap) {
  _inherits(AMapEngine, _BaseMap);
  var _super = _createSuper(AMapEngine);
  function AMapEngine() {
    _classCallCheck(this, AMapEngine);
    return _super.apply(this, arguments);
  }
  _createClass(AMapEngine, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(options) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return MapLoader.load('amap');
              case 3:
                this.map = new window.AMap.Map(this.containerId, options);
                return _context.abrupt("return", this.map);
              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                console.log('AutoConsole ~ AMapEngine ~ init ~ error:', _context.t0);
              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 7]]);
      }));
      function init(_x) {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "reverseAddressFromLngLat",
    value: function reverseAddressFromLngLat(lng, lat) {
      return new Promise(function (resolve) {
        var geocoder = new window.AMap.Geocoder({
          radius: 1000,
          extensions: 'all'
        });
        //逆地理编码
        geocoder.getAddress(new window.AMap.LngLat(lng, lat), function (status, result) {
          if (status === 'complete') {
            resolve(result.regeocode.formattedAddress);
          } else {
            resolve('');
          }
        });
      });
    }
  }, {
    key: "addControls",
    value: function addControls(controls) {
      this.map.addControl(controls);
      return this;
    }
  }, {
    key: "createLngLat",
    value: function createLngLat(lng, lat) {
      return new window.AMap.LngLat(lng, lat);
    }
  }, {
    key: "setCenter",
    value: function setCenter(position) {
      this.map.setCenter(position);
      return this;
    }
  }, {
    key: "createGeolocation",
    value: function createGeolocation(options) {
      var geo = new window.AMap.Geolocation(options);
      // 兼容tianditu
      geo.getCurrentPositionFix = geo.getCurrentPosition;
      return geo;
    }
  }, {
    key: "creaeteDistrictSearch",
    value: function creaeteDistrictSearch(options) {
      return new window.AMap.DistrictSearch(options);
    }
  }, {
    key: "setFitView",
    value: function setFitView() {
      this.map.setFitView();
      return this;
    }
  }, {
    key: "panTo",
    value: function panTo(position) {
      this.map.panTo(position);
      return this;
    }
  }, {
    key: "clearInfoWindow",
    value: function clearInfoWindow() {
      this.map.clearInfoWindow();
      return this;
    }
  }, {
    key: "clearMap",
    value: function clearMap() {
      this.map.clearMap();
      return this;
    }
  }, {
    key: "removeOverLay",
    value: function removeOverLay(marker) {
      this.map.remove(marker);
      return this;
    }
  }, {
    key: "addOverLay",
    value: function addOverLay(marker) {
      this.map.add(marker);
      return this;
    }
  }, {
    key: "createMarker",
    value: function createMarker(options) {
      var map = options.map,
        others = _objectWithoutProperties(options, ["map"]);
      var marker = new window.AMap.Marker(others);
      if (map) {
        this.addOverLay(marker);
      }
      return marker;
    }
  }, {
    key: "createPlaceSearch",
    value: function createPlaceSearch(options) {
      return new window.AMap.PlaceSearch(options);
    }
  }, {
    key: "createGeocoder",
    value: function createGeocoder(options) {
      var geocoder = new window.AMap.Geocoder(options);
      geocoder.getPoint = function (address, callback) {
        geocoder.getLocation(address, function (status, result) {
          if (status === 'complete' && result.info === 'OK' && result.geocodes.length) {
            var obj = {
              status: '0',
              location: {
                lon: result.geocodes[0].location.lng,
                lat: result.geocodes[0].location.lat
              }
            };
            callback(obj);
          } else {
            callback({
              status: 'error'
            });
          }
        });
      };
      return geocoder;
    }
  }, {
    key: "createInfoWindow",
    value: function createInfoWindow(options) {
      return new window.AMap.InfoWindow(options);
    }
  }, {
    key: "createPixel",
    value: function createPixel(x, y) {
      return new window.AMap.Pixel(x, y);
    }
  }, {
    key: "createIcon",
    value: function createIcon(options) {
      return new window.AMap.Icon(options);
    }
  }, {
    key: "createSize",
    value: function createSize(x, y) {
      return new window.AMap.Size(x, y);
    }
  }, {
    key: "openInfoWindow",
    value: function openInfoWindow(marker, infoWindow) {
      infoWindow.open(this.map, marker.getPosition());
    }
  }, {
    key: "createPolygon",
    value: function createPolygon(options) {
      return new window.AMap.Polygon(options);
    }
  }, {
    key: "on",
    value: function on(target, eventName, handler) {
      target.on(eventName, handler);
    }
  }, {
    key: "off",
    value: function off(target, eventName, handler) {
      target.off(eventName, handler);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.map && this.map.destroy();
    }
  }]);
  return AMapEngine;
}(BaseMap);
export { AMapEngine as default };